import { Spinner } from '@/components/atoms/Spinner'
import { LootboxProvider } from '@/context/LootboxProvider'
import { Center } from '@chakra-ui/react'
import { Suspense } from 'react'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense
        fallback={
          <Center>
            <Spinner />
          </Center>
        }
      >
        <LootboxProvider>{children}</LootboxProvider>
      </Suspense>
    </>
  )
}
